import React, { Component } from 'react'
import './Dropzone.css'

class Dropzone extends Component {
  constructor(props) {
    super(props)
    this.state = { hightlight: false, filename:'' }
    this.fileInputRef = React.createRef();
  }

  openFileDialog = () => {
    if (this.props.disabled) return;
    this.fileInputRef.current.click()
  }

  onFilesAdded = (evt) => {
    if (this.props.disabled) return
    const files = evt.target.files

    this.setState({ filename: files[0].name});

    if (this.props.onFilesAdded) {
      const array = this.fileListToArray(files)
      this.props.onFilesAdded(array)
    }
  }

  onDragOver = (evt) =>{
    evt.preventDefault()

    if (this.props.disabled) return

    this.setState({ hightlight: true })
  }

  onDragLeave = () => {
    this.setState({ hightlight: false })
  }

  onDrop = (event) => {
    event.preventDefault()

    if (this.props.disabled) return

    const files = event.dataTransfer.files
    if (this.props.onFilesAdded) {
      const array = this.fileListToArray(files)
      this.props.onFilesAdded(array)
    }
    this.setState({ hightlight: false })
  }

  fileListToArray(list) {
    const array = []
    for (var i = 0; i < list.length; i++) {
      array.push(list.item(i))
    }
    return array
  }

  render() {

    const AcceptFiles = this.props.Accept === "xlsx" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" : this.props.Accept === "img" ? "image/jpeg, image/gif, image/png" : this.props.Accept === "pdf" ? "application/pdf": "text/plain";
    return (
      <div
        className={`Dropzone ${this.state.hightlight ? 'Highlight' : ''}`}
        onDragOver={this.onDragOver}
        onDragLeave={this.onDragLeave}
        onDrop={this.onDrop}
        onClick={this.openFileDialog}
        style={{ cursor: this.props.disabled ? 'default' : 'pointer' }}
      >
        <input
          ref={this.fileInputRef}
          className="FileInput"
          type="file"
          onChange={this.onFilesAdded}
          accept={AcceptFiles} /> 
       
       
        {this.state.filename.length> 2 ? (<label>{this.state.filename}</label>):(<span>{this.props.title}</span>)}
        
      </div>
    )
  }
}


export default Dropzone;